import {RESPONSIVE_BREAKPOINT_MOBILE, RESPONSIVE_CHANGE} from "../constants";

export const responsiveChange = (width, height) => {
  return {
    type: RESPONSIVE_CHANGE,
    mobile: width < RESPONSIVE_BREAKPOINT_MOBILE,
    width,
    height
  }
};